import { useEffect } from './core.js';
export function useDebouncedEffect(effect, deps, delay = 300) {
    useEffect(() => {
        const timerId = globalThis.setTimeout(effect, delay);
        return () => {
            globalThis.clearTimeout(timerId);
        };
    }, deps);
}
